import { WithLoader } from '@/components/WithLoader';
import { CompetitorMediaEffectOnClientRevenueGraph } from '@/dashboards/CompetitorsMediaInvestment/components/CompetitorMediaEffectOnClientRevenueGraph';
import { useCompetitorsMediaInvestmentContext } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentContext';
import { Typography } from '@analytical-alley/ui';
import { IconArrowDown, IconArrowUp } from '@tabler/icons-react';
import React from 'react';
import { cn } from '@/utils';
import { useDashboardGlobalContext } from '@/dashboards/providers/dashboardGlobalContext';

export const CompetitorMediaEffectOnClientRevenueSection = () => {
    const {
        competitorsMediaEffectData: {
            totalInvestment: totalCompetitorContribution,
        },
        kpiData,
        isLoading,
        isFetching,
    } = useCompetitorsMediaInvestmentContext();
    const { contributionFormatter } = useDashboardGlobalContext();

    const totalContribution = kpiData.reduce((acc, row) => acc + row.kpi, 0);

    const revenueEffectToClient =
        totalContribution === 0
            ? 0
            : (totalCompetitorContribution / totalContribution) * 100;

    const isEmptyResults =
        !isFetching &&
        !isLoading &&
        (totalCompetitorContribution === 0);

    if (isEmptyResults) {
        return (
            <div className="glass-tile p-6">
                <div className="flex justify-between mb-4">
                    <Typography variant="titleS">
                        Total Competitor media effect on your KPI:
                    </Typography>
                </div>
                <div className="relative w-full">
                    <Typography
                        className="font-mono text-center"
                        variant="bodyM"
                    >
                        No impact on your KPI was detected!
                    </Typography>
                </div>
            </div>
        );
    }

    const isNegative = revenueEffectToClient <= 0;

    return (
        <div className="glass-tile p-6">
            <div className="flex mb-4 gap-3">
                <Typography variant="titleS">
                    Total Competitor media effect on your KPI:
                </Typography>
                {!isLoading && !isFetching && (
                    <div className="font-mono flex flex-row items-center">
                        {isNegative ? (
                            <IconArrowDown size={22} color="#FF3766" />
                        ) : (
                            <IconArrowUp size={22} color="#00B000" />
                        )}
                        <Typography
                            className={cn({
                                'text-rose-500 dark:text-rose-500': isNegative,
                                'text-green-400 dark:text-green-400':
                                    !isNegative,
                            })}
                            variant="titleS"
                        >
                            {revenueEffectToClient.toFixed(2)}% (
                            {contributionFormatter(totalCompetitorContribution)})
                        </Typography>
                    </div>
                )}
            </div>
            <WithLoader isLoading={isLoading} isFetching={isFetching}>
                <CompetitorMediaEffectOnClientRevenueGraph />
            </WithLoader>
        </div>
    );
};
